import { useBasePackagePlan } from 'utils/customHooks/useBasePackagePlan';

import { RequestAddQuantityModal } from '../RequestAddQuantityModal/RequestAddQuantityModal';

interface RequestLicensesModalProps {
  orgId: number;
  featureName: string;
  modalOpen: boolean;
  onClose: () => void;
  // Falls back to the org's base package when not provided.
  packageId?: number;
}

export const RequestLicensesModal = ({
  modalOpen,
  onClose: closeCallback,
  orgId,
  featureName,
  packageId,
}: RequestLicensesModalProps) => {
  const { basePackagePlan } = useBasePackagePlan(orgId);
  const orgBasePackageId = basePackagePlan?.packagePlan?.package?.id;

  return (
    <RequestAddQuantityModal
      orgId={orgId}
      open={modalOpen}
      onClose={closeCallback}
      packageId={packageId ?? orgBasePackageId}
      featureName={featureName}
    />
  );
};
